import ReglementsTab from "./ReglementsTab";

// Règlements V2 : même composant (mêmes données, actions et modaux éprouvés), avec la refonte UI
// du tableau activée via variant="v2". La V1 (sans variant) reste strictement inchangée.
const ReglementsTabV2 = (props) => <ReglementsTab {...props} variant="v2" />;

export default ReglementsTabV2;
